import { useQuery } from '@tanstack/react-query';

import { type Partner, PartnerConfig } from '@/configs/partner';
import { Account } from '@/types';

import { fetchSessionData } from '../utils/fetchSessionData';

interface SessionDataProps {
  email: string;
  partner: Partner;
  partnerConfig: PartnerConfig;
  enabled: boolean;
}

interface SessionDataResponse {
  data?: {
    account?: Account;
  };
  isLoading: boolean;
  isError: boolean;
}

const useSessionData = ({
  email,
  partner,
  partnerConfig,
  enabled,
}: SessionDataProps): SessionDataResponse => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['fetchSessionData', email],
    queryFn: async () => {
      const response = await fetchSessionData(email, partner, partnerConfig);
      if (response.error) {
        throw new Error(JSON.stringify(response.error));
      }
      if (!response.data) {
        throw new Error('No data returned from fetchSessionData');
      }
      return response.data;
    },
    enabled,
    // wanted to stick closer to the manual state implementation this is replacing to limit useSession useEffect fires.
    staleTime: Infinity,
  });

  return { data, isLoading, isError };
};

export default useSessionData;
